"use client";

import { Button, cn } from "@saridana-core/react-ui-kit";
import { TButtonLink, TProductCtaSection } from "@shared/types";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function ProductCtaSection({ illustration, menuButtons, buttonLink, title, description, subTitle }: TProductCtaSection) {
  const currentPath = usePathname();

  return (
    <div
      className="relative text-white min-h-[716px]"
      style={{
        background: "linear-gradient(279.77deg, #08475B 5.09%, #1DB0DE 77.58%)",
      }}
    >
      {illustration?.data?.attributes?.url && (
        <Image
          src={illustration?.data?.attributes?.url}
          alt={illustration?.data?.attributes?.alternativeText || illustration?.data?.attributes?.name || "Retail CTA Illustration"}
          width={illustration?.data?.attributes?.width}
          height={illustration?.data?.attributes?.height}
          className="max-w-full sm:max-w-[80%] lg:max-w-[65%] xl:max-w-[60rem] object-cover bottom-0 right-0 absolute z-1 object-center lg:object-left-bottom"
        />
      )}

      <div className="pt-20 sm:pt-28 pb-[25rem] lg:pb-44 container relative">
        {menuButtons?.length ? (
          <div className="flex flex-col min-[390px]:flex-row min-[390px]:items-center min-[390px]:space-x-4 space-y-4 min-[390px]:space-y-0 mb-12">
            {menuButtons?.map((optionButton: TButtonLink, index: number) => (
              <Button
                key={`option-button-${index}`}
                variant={currentPath == optionButton.href ? "default" : "outline"}
                className={cn(
                  "rounded-2xl h-[50px] sm:h-[60px] px-7 text-lg sm:text-xl font-semibold",
                  currentPath == optionButton.href
                    ? "text-primary bg-white hover:text-primary pointer-events-none"
                    : "text-white bg-transparent hover:text-primary",
                )}
              >
                <Link href={optionButton.href} className="flex items-center space-x-2">
                  <span>{optionButton?.text}</span>

                  {optionButton?.icon?.data?.attributes?.url && (
                    <Image
                      src={optionButton?.icon?.data?.attributes?.url}
                      alt={
                        optionButton?.icon?.data?.attributes?.alternativeText ||
                        optionButton?.icon?.data?.attributes?.name ||
                        "Retail CTA Option Button"
                      }
                      width={optionButton?.icon?.data?.attributes?.width}
                      height={optionButton?.icon?.data?.attributes?.height}
                      className="w-5 h-5"
                    />
                  )}
                </Link>
              </Button>
            ))}
          </div>
        ) : null}

        {subTitle && (
          <h6 className="font-bold text-[20px] leading-[140%] tracking-[2px] text-primary-100 mb-6">{subTitle || "CTA Subtitle"}</h6>
        )}

        <div className="sm:max-w-[700px] lg:max-w-[650px] mb-10">
          <h3 className="font-bold text-[48px] sm:text-[72px] leading-[111.00000000000001%] mb-6">{title || "CTA Title"}</h3>
          <p className="text-[20px] sm:text-[24px] leading-[134%] mb-6">{description || "Cta description"}</p>
        </div>

        {buttonLink?.href && (
          <Button variant={"default"} className="rounded-2xl h-[60px] px-8 text-xl font-bold text-primary bg-white hover:bg-white">
            {buttonLink?.icon?.data?.attributes?.url && (
              <Image
                src={buttonLink?.icon?.data?.attributes?.url}
                alt={
                  buttonLink?.icon?.data?.attributes?.alternativeText ||
                  buttonLink?.icon?.data?.attributes?.name ||
                  "Retail CTA Button Link Icon"
                }
                width={buttonLink?.icon?.data?.attributes?.width}
                height={buttonLink?.icon?.data?.attributes?.height}
                className="w-7 h-7 text-primary"
              />
            )}
            <Link href={buttonLink.href} target={buttonLink.target}>
              {buttonLink?.text}
            </Link>
          </Button>
        )}
      </div>
    </div>
  );
}
